<template>
  <div>
    <!-- 사업장 정보 -->
    <workplace-material-company-list ref="fieldSection" :list="fieldList" :showDetail="true" @select="handleSelectField"/>

    <!-- 사업장별 업체 정보 -->
    <company-company-list ref="companySelection" :list="companyList" />

    <!-- 사용자 정보 -->
    <company-user-auth-module title="시스템 사용자 정보" :users="users" type="info"/>

  </div>
</template>

<script>
import CompanyFieldList from '@/views/_BS/components/CompanyFieldList'
import CompanyCompanyList from '@/views/_BS/components/CompanyCompanyList'
import CompanyUserAuthModule from '@/views/_BS/components/CompanyUserAuthModule'
import WorkplaceMaterialCompanyList from "@/views/_BS/components/WorkplaceMaterialCompanyList.vue";

export default {
  components: {
    WorkplaceMaterialCompanyList,
    CompanyUserAuthModule,
    CompanyCompanyList,
    CompanyFieldList,
  },
  props: {
    companyId: String | Number,
  },
  data () {
    return {
      fieldType: '원료·제조물 사업장',
      fieldTypeCode: 'workplace-material',
      selectedCompanyId: 0,
      selectFieldId: 0,
    }
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },

    fieldList () {
      return this.$store.state.company.fieldList
    },

    companyList () {
      if (this.selectFieldId === 0) {
        return []
      }
      return (this.selectFieldId && this.$store.state.project.fieldCompany) ? this.$store.state.project.fieldCompany.data : []
    },

    users () {
      if (this.selectFieldId === 0) {
        return []
      }
      return (this.selectFieldId && this.$store.state.project.fieldUsers) ? this.$store.state.project.fieldUsers.data : []
    }
  },
  watch: {
    companyId () {
      this.selectFieldId = 0
      this.selectedCompanyId = this.companyId
    },
    selectedCompanyId (/*value*/) {
      this.selectFieldId = 0
      this.loadCompanyInfo()
    }
  },
  mounted () {

    const myInfo = this.$store.state.auth.userInfo
    this.selectedCompanyId = myInfo.company_id

    this.loadCompanyInfo()
  },
  methods: {

    loadCompanyInfo () {
      this.$refs.fieldSection.clearFieldInfo();
      this.$refs.companySelection.clearCompanyInfo();
      this.selectFieldId = 0

      this.$store.dispatch('company/LOAD_COMPANY', {companyId: this.selectedCompanyId}).then(value => {
        this.companyInfo = value

        if (this.companyInfo.id) {
          const companyId = this.companyInfo.id
          const projectId = this.projectId
          const fieldCode = this.fieldTypeCode
          this.$store.dispatch('company/LOAD_COMPANY_FIELD', {companyId, projectId, fieldCode, perPage: 10000});
        }
      })
    },

    // company-company-list
    loadFieldCompany () {
      if (this.selectFieldId) {
        this.$store.dispatch('project/LOAD_FIELD_COMPANYS', {fieldId: this.selectFieldId})
      }
    },

    loadFieldUsers () {
      if (this.selectFieldId) {
        this.$store.dispatch('project/LOAD_FIELD_USERS', {fieldId: this.selectFieldId})
      }
    },

    handleSelectField (field) {
      if (field && field.id) {
        this.selectFieldId = field.id;

        this.loadFieldCompany();
        this.loadFieldUsers();
      }
    },
  }
}
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.size-search {
  width: 200px;
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
